type BranchNode = { level: number; data: { name: string } };
type BranchLabel = { label: string; description?: string };

const formatSkillBranchLabel = (skill: string, granularity: string) => {
  return `${skill.split('/')[0]?.trim() ?? skill} ... ${granularity}`;
};

export const ricsAndCompanyBranchLabels = (
  parentNode: BranchNode
): BranchLabel => {
  const { level, data } = parentNode;
  const label = (() => {
    switch (level) {
      case -1:
        return 'Industry k10';
      case 0:
        return `${data.name} k400`;
      case 1:
        return `${data.name} Companies`;
      default:
        return 'Industry';
    }
  })();
  return { label };
};

export const roleBranchLabels = (parentNode: BranchNode): BranchLabel => {
  const { level, data } = parentNode;
  const { label, description } = (() => {
    switch (level) {
      case -1:
        return {
          label: 'Job Category',
          description:
            'Job Category is a set of distinct occupations. At this level of granularity, roles are bucketed into 7 parts.',
        };
      case 0:
        return {
          label: `${data.name} k150`,
          description:
            'Role k150 is a set of distinct occupations. At this level of granularity, roles are bucketed into 150 parts.',
        };
      case 1:
        return {
          label: `${data.name} k1500`,
          description:
            'Role k1500 is a set of distinct occupations. At this level of granularity, roles are bucketed into 1,500 parts.',
        };
      case 2:
        return {
          label: `${data.name} k15000`,
          description:
            'Role k15000 is a set of distinct occupations. At this level of granularity, roles are bucketed into 15,000 parts.',
        };
      default:
        return {
          label: 'Role',
          description: 'Role is a set of distinct occupations',
        };
    }
  })();
  return { label, description };
};

export const geographyBranchLabels = (parentNode: BranchNode): BranchLabel => {
  const { level } = parentNode;
  const label = (() => {
    switch (level) {
      case -1:
        return 'Region';
      case 0:
        return 'Country';
      case 1:
        return 'Metro Area';
      case 2:
        return 'City';
      default:
        return 'Region';
    }
  })();
  return { label };
};

export const geographyAdministrativeBranchLabels = (
  parentNode: BranchNode
): BranchLabel => {
  const { level } = parentNode;
  const label = (() => {
    switch (level) {
      case -1:
        return 'Region';
      case 0:
        return 'Country';
      case 1:
        return 'State';
      case 2:
        return 'City';
      default:
        return 'Region';
    }
  })();
  return { label };
};

export const skillsBranchLabels = (parentNode: BranchNode): BranchLabel => {
  const { level, data } = parentNode;
  const label = (() => {
    switch (level) {
      case -1:
        return 'Skill k75';
      case 0:
        return formatSkillBranchLabel(data.name, 'k700');
      case 1:
        return formatSkillBranchLabel(data.name, 'k3000');
      default:
        return 'Skills';
    }
  })();
  return { label };
};
